// src/components/store/sections/hero-banner/HeroV9BentoshowcaseRoyalViolet.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV9BentoshowcaseRoyalViolet(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={9}
      archKey="bento_showcase"
      archLabel="Bento Multi-Tile Hero"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      {...props}
    />
  );
}
